import { render, staticRenderFns } from "./VReports.vue?vue&type=template&id=50a91e59"
import script from "./VReports.vue?vue&type=script&lang=js"
export * from "./VReports.vue?vue&type=script&lang=js"
import style0 from "./VReports.vue?vue&type=style&index=0&id=50a91e59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports